import { createGlobalStyle } from 'styled-components'
import { typography } from '../typography'

export const HTMLGlobalStyle = createGlobalStyle`
  .editor-list-ul {
    padding-left: 25px;
    text-align: left !important;
  }
  .editor-list-ol__1 {
    padding-left: 40px;
    text-align: left !important;
  }
  
  .editor-listItem {
    ${typography.body.regular}
  }

  .editor-paragraph {
    ${typography.body.regular};
    &:not(:first-child) {
      margin-top: 8px;
    }
	}

	.editor-heading-h2 {
    ${typography.head2.bold};
    &:not(:first-child) {
      margin-top: 40px;
    }
	}

	.editor-heading-h3 {
    ${typography.head3.bold};
    &:not(:first-child) {
      margin-top: 32px;
    }
	}

	.editor-heading-h4 {
    ${typography.head4.bold};
    &:not(:first-child) {
      margin-top: 24px;
    }
	}
`
